import React, {createRef, ReactElement, RefObject} from 'react';
import MPage, {MPageProps} from '../Toolkit/Components/Shell/Page';
import MComponent from '../Toolkit/Components/Component';
import MForm, {MFormOutcome} from '../Toolkit/Components/Controls/Form';
import MToolbar from '../Toolkit/Components/Controls/Toolbar';
import MButton from '../Toolkit/Components/Controls/Button';
import MSpacer from '../Toolkit/Components/Controls/Spacer';
import WithRouterProps from '../Toolkit/WithRouterProps';
import {MNullable, toErrorMessage} from '../Toolkit/Utils';
import WithRouter from '../Toolkit/WithRouter';
import {
    CancelSafeDigReply,
    ProjectReply,
    SafeDig,
    SafeDigListReply,
    SafeDigNoteReply,
    SafeDigReply,
    StatusMessageReply,
    UpdateSafeDigReply,
    UpdateSafeDigValidator
} from '../Api/SafeDigTypes';
import {Note} from '../Api/NoteTypes';
import * as Yup from 'yup';
import {MCloseIconName, MSaveIconName} from '../Toolkit/Icons';
import {FieldProps, FormikHelpers} from 'formik';
import MFormSection from '../Toolkit/Components/Controls/FormSection';
import MFormFieldControl from '../Toolkit/Components/Controls/FormFieldControl';
import MFormControl from '../Toolkit/Components/Controls/FormControl';
import MTextBox from '../Toolkit/Components/Controls/TextBox';
import MCalendar from '../Toolkit/Components/Controls/Calendar';
import MNumericBox from './Components/NumericBox';
import {UpdateSafeDigRequest, SafeDigUpdateSupervisionRequest, NoteCreateDto, SafeDigSendRequest} from '../Api/SafeDigsClients';
import StatusControl from './Components/StatusControl';
import {SafeDigClient} from '../Api/SafeDigsClients';
import {SafeDigFileClient} from '../Api/SafeDigFilesClients';
import {SafeDigTaskClient} from '../Api/SafeDigTaskClients';
import {AuditLogClient} from '../Api/AuditLogClients';
import {CreateSafeDigFileRequest, ChangeFileStateRequest} from '../Api/SafeDigFilesClients';
import FileUploadDialog, {UploadData} from './Dialogs/FileUploadDialog';
import FileStatusDialog, {FileStatusResult} from './Dialogs/FileStatusDialog';
import {CreateSafeDigTaskReply, SafeDigTask, SafeDigTaskListReply} from '../Api/SafeDigTaskTypes';
import {CreateSafeDigTaskRequest, UpdateSafeDigTaskRequest} from '../Api/SafeDigTaskClients';
import {MTableProps} from '../Toolkit/Components/Controls/Table';
import TaskListControl from './Components/TaskListControl';
import FileListControl from './Components/FileListControl';
import {Divider} from 'primereact/divider';
import {Messages, MessagesSeverityType} from 'primereact/messages';
import skullLogo from './Images/Skull40.png';
import {TaskData} from './Dialogs/TaskEditDialog';
import {ReleaseIconName, SendIconName, GotoIconName, JobAreas} from './SafeDigConstants';
import JobReleaseDialog from './Dialogs/JobReleaseDialog';
import {withMsal, WithMsalProps} from '@azure/msal-react';
import {MDropDownItem} from '../Toolkit/Components/Controls/DropDownOption';
import MDropDown from '../Toolkit/Components/Controls/DropDown';
import {CreateSafeDigFileReply, SafeDigFile, SafeDigFileListReply, UpdateSafeDigFileReply} from '../Api/SafeDigFileTypes';
import {AuditLog, AuditLogListReply} from '../Api/AuditTypes';
import AuditListControl from './Components/AuditListControl';
import NSwagAdapter from '../Toolkit/Api/NSwagAdapter';
import MNSwagClientConfiguration from '../Toolkit/Api/NSwagClientConfiguration';
import SafeDigAccessTokenProvider from '../Api/SafeDigAccessTokenProvider';
import NoteListControl from './Components/NoteListControl';
import JobSendDialog from './Dialogs/JobSendDialog';
import SubJobControl from './Components/SubJobControl';
import TextArea from './Components/TextArea';
import CancelDialog from './Dialogs/CancelDialog';
import NoticeListControl from './Components/NoticeListControl';
import {NoticeClient} from '../Api/NoticeClients';
import {Notice, NoticeReplyMulti} from '../Api/NoticeTypes';

/** */
type RouteParams = {
    id: number;
};

type SafeDigTaskRow = {
    data: SafeDigTask;
}

type SafeDigFileRow = {
    data: SafeDigFile;
}

type AuditLogRow = {
    data: AuditLog;
}

type SafeDigNoteRow = {
    data: Note;
}

type SubJobRow = {
    data: SafeDig;
}

type ExpiryDates = {
    gas: MNullable<Date>;
    electric: MNullable<Date>;
    water: MNullable<Date>;
    bapa: MNullable<Date>;
    telecoms: MNullable<Date>;
    lsbud: MNullable<Date>;
}

/** */
type Props = WithMsalProps & WithRouterProps<RouteParams> & {}

/** */
type State = {
    pageTitle: string;
    pageSubtitle: string;
    page: MPageProps;
    id: string;
    form: {
        id: string;
        data: SafeDig;
        tasks: MTableProps<SafeDigTaskRow>;
        files: MTableProps<SafeDigFileRow>;
        audit: MTableProps<AuditLogRow>;
        notes: MTableProps<SafeDigNoteRow>;
        subJobs: MTableProps<SubJobRow>;
        notices: Notice[];
        isSubmitting: boolean;
        validationSchema: any;
    }
    projectList: MDropDownItem<number>[];
    expiryDates: ExpiryDates;
}

class EditSafeDigPage extends MComponent<Props, State> {

    private m_updateCount: number;
    private readonly m_pageRef: RefObject<MPage>;
    private readonly m_fileUploadRef: RefObject<FileUploadDialog>;
    private readonly m_fileStatusRef: RefObject<FileStatusDialog>;
    private readonly m_jobReleaseRef: RefObject<JobReleaseDialog>;
    private readonly m_cancelRef: RefObject<CancelDialog>;
    private readonly m_jobSendRef: RefObject<JobSendDialog>;
    private readonly m_messageRef: RefObject<Messages>;
    private readonly m_formRef: RefObject<MForm<SafeDig>>;
    private readonly m_projectRef: RefObject<MDropDown<number>>;
    private readonly m_safedigClient: NSwagAdapter<SafeDigClient>;
    private readonly m_safedigFileClient: NSwagAdapter<SafeDigFileClient>;
    private readonly m_safedigTaskClient: NSwagAdapter<SafeDigTaskClient>;
    private readonly m_noticeClient: NSwagAdapter<NoticeClient>;
    private readonly m_auditlogClient: NSwagAdapter<AuditLogClient>;
    private readonly m_areaRef: RefObject<MDropDown<string>>;
    private m_areaValue: string;

    public constructor(props: Props) {
        super(props);

        this.bindMethods();

        this.m_pageRef = createRef<MPage>();
        this.m_fileUploadRef = createRef<FileUploadDialog>();
        this.m_fileStatusRef = createRef<FileStatusDialog>();
        this.m_jobReleaseRef = createRef<JobReleaseDialog>();
        this.m_cancelRef = createRef<CancelDialog>();
        this.m_jobSendRef = createRef<JobSendDialog>();
        this.m_messageRef = createRef<Messages>();
        this.m_formRef = createRef<MForm<SafeDig>>();
        this.m_projectRef = createRef<MDropDown<number>>();
        this.m_areaRef = createRef<MDropDown<string>>();
        this.m_areaValue = 'Aintree';

        this.m_safedigClient = new NSwagAdapter<SafeDigClient>(new SafeDigClient(
            new MNSwagClientConfiguration(process.env.REACT_APP_SAFEDIGS_API_KEY!,
                new SafeDigAccessTokenProvider(this.props.msalContext))));
        this.m_safedigFileClient = new NSwagAdapter<SafeDigFileClient>(new SafeDigFileClient(
            new MNSwagClientConfiguration(process.env.REACT_APP_SAFEDIGS_API_KEY!,
                new SafeDigAccessTokenProvider(this.props.msalContext))));
        this.m_safedigTaskClient = new NSwagAdapter<SafeDigTaskClient>(new SafeDigTaskClient(
            new MNSwagClientConfiguration(process.env.REACT_APP_SAFEDIGS_API_KEY!,
                new SafeDigAccessTokenProvider(this.props.msalContext))));
        this.m_noticeClient = new NSwagAdapter<NoticeClient>(new NoticeClient(
            new MNSwagClientConfiguration(process.env.REACT_APP_SAFEDIGS_API_KEY!,
                new SafeDigAccessTokenProvider(this.props.msalContext))));
        this.m_auditlogClient = new NSwagAdapter<AuditLogClient>(new AuditLogClient(
            new MNSwagClientConfiguration(process.env.REACT_APP_SAFEDIGS_API_KEY!,
                new SafeDigAccessTokenProvider(this.props.msalContext))));
        this.m_updateCount = 0;

        this.initializeState();
    }

    private bindMethods(): void {
        this.isFormDisabled = this.isFormDisabled.bind(this);
        this.isReleaseDisabled = this.isReleaseDisabled.bind(this);
        this.isJobComplete = this.isJobComplete.bind(this);

        this.closeButton_Click = this.closeButton_Click.bind(this);
        this.isSendButtonDisabled = this.isSendButtonDisabled.bind(this);
        this.isCancelButtonDisabled = this.isCancelButtonDisabled.bind(this);
        this.form_onBeforeSubmit = this.form_onBeforeSubmit.bind(this);
        this.form_onSubmit = this.form_onSubmit.bind(this);
        this.form_onError = this.form_onError.bind(this);
        this.form_onAfterSubmit = this.form_onAfterSubmit.bind(this);
        this.page_onLoadData = this.page_onLoadData.bind(this);
        this.getToolbarTemplate = this.getToolbarTemplate.bind(this);

        this.onUploadFile = this.onUploadFile.bind(this);
        this.onNewNote = this.onNewNote.bind(this);
        this.onNavigate = this.onNavigate.bind(this);
        this.saveTaskData = this.saveTaskData.bind(this);
        this.ChangeFileIncludeStatus = this.ChangeFileIncludeStatus.bind(this);
        this.fileStatusDialog_Close = this.fileStatusDialog_Close.bind(this);
        this.jobReleaseDialog_Close = this.jobReleaseDialog_Close.bind(this);
        this.jobSendDialog_onClose = this.jobSendDialog_onClose.bind(this);
        this.cancelDialog_onClose = this.cancelDialog_onClose.bind(this);
        this.releaseButton_Click = this.releaseButton_Click.bind(this);
        this.send_Click = this.send_Click.bind(this);
        this.goto_Click = this.goto_Click.bind(this);
        this.cancel_Click = this.cancel_Click.bind(this);
        this.onFileListRefresh = this.onFileListRefresh.bind(this);
        this.readLineExpiryDates = this.readLineExpiryDates.bind(this);
        this.readExpiryDate = this.readExpiryDate.bind(this);
    }

    private initializeState(): void {
        const page: MPageProps = {locked: false};

        const data: SafeDig = {
            safeDigsId: 0,
            estimate: '',
            project: 1,
            requestor: '',
            address1: '',
            address2: '',
            address3: '',
            county: '',
            postcode: '',
            workDescription: '',
            northing: 0,
            easting: 0,
            northing2: 0,
            easting2: 0,
            supervisionDate: null,
            requiredDate: new Date(),
            receivedDate: new Date(),
            waterStatus: 0,
            bapaStatus: 0,
            telecomsStatus: 0,
            electricStatus: 0,
            gasStatus: 0,
            lsbudStatus: 0,
            digStatus: 0,
            hotJob: false,
            quarantine: false,
            parent: -1,
            uploadUser: '',
            uploadDate: new Date(),
            expiryDate: new Date()
        };

        const validationSchema: any = Yup.object().shape({
            estimate: UpdateSafeDigValidator.estimateFunc(this.m_safedigClient, this.props.match.params.id),
            address1: UpdateSafeDigValidator.address1,
            address2: UpdateSafeDigValidator.address2,
            address3: UpdateSafeDigValidator.address3,
            county: UpdateSafeDigValidator.county,
            postcode: UpdateSafeDigValidator.postcode,
            workDescription: UpdateSafeDigValidator.workDescription,
            northing: UpdateSafeDigValidator.northing,
            easting: UpdateSafeDigValidator.easting,
            requiredDate: UpdateSafeDigValidator.requiredDate
        });

        const expiryDates: ExpiryDates = {
            gas: null,
            electric: null,
            water: null,
            bapa: null,
            telecoms: null,
            lsbud: null
        };

        //  Table
        const tasks: MTableProps<SafeDigTaskRow> = {
            rowData: []
        };

        const files: MTableProps<SafeDigFileRow> = {
            rowData: []
        };

        const audit: MTableProps<AuditLogRow> = {
            rowData: []
        };

        const notes: MTableProps<SafeDigNoteRow> = {
            rowData: []
        };

        const subJobs: MTableProps<SubJobRow> = {
            rowData: []
        };

        this.state = {
            pageTitle: '',
            pageSubtitle: '',
            page: page,
            id: '',
            form: {
                id: 'editSafeDigForm',
                data: data,
                tasks: tasks,
                files: files,
                audit: audit,
                notes: notes,
                notices: [],
                subJobs: subJobs,
                isSubmitting: false,
                validationSchema: validationSchema
            },
            projectList: [],
            expiryDates: expiryDates
        };
    }

    //region :: update dialog ::
    /*private navigateToSafeDigButton_onClick(): void {
        this.props.history.replace(`/safedigs/${this.state.form.data.estimate}`);
    }*/

    //endregion

    private async onUploadFile(data: UploadData) {
        const userName = this.props.msalContext.accounts[0].name;

        const createRequest = new CreateSafeDigFileRequest({
            safeDigsId: this.state.form.data.safeDigsId,
            fileType: data.fileType,
            appArea: 0,
            lineSearchPositive: data.searchPositive,
            startDate: undefined,
            expiryDate: data.expiryDate,
            file: data.file!,
            fileInfo: data.fileInfo,
            fileName: data.fileName,
            user: userName
        });

        if(data.fileType === 7 /*Document*/){
            const result = await this.m_safedigFileClient.callWithReply(CreateSafeDigFileReply, (client) => client.postMisc(createRequest));
            result.throwIfFailed();
        } else {
            const result = await this.m_safedigFileClient.callWithReply(CreateSafeDigFileReply, (client) => client.post(createRequest));
            result.throwIfFailed();
        }

        //Refresh page before closing dialog.
        await this.page_onLoadData();
        this.m_fileUploadRef.current!.hide();
    }

    private async onNewNote(data: string) {
        const userName = this.props.msalContext.accounts[0].name;

        await this.m_safedigClient.call((client) => client.addNote(new NoteCreateDto({
            safeDigsId: this.state.form.data.safeDigsId,
            noteText: data,
            user: userName
        })));

        await this.readNoteData(this.state.form.data.safeDigsId);
    }

    private async jobSendDialog_onClose(emailAddresses: string[]) {
        const userName = this.props.msalContext.accounts[0].name;

        const sendResult = await this.m_safedigClient.callWithReply(
            UpdateSafeDigReply,
            (client) => client.send(new SafeDigSendRequest({
                safeDigId: this.state.form.data.safeDigsId,
                emailAddresses: emailAddresses,
                user: userName
            })));

        sendResult.throwIfFailed();

        await this.page_onLoadData();
    }

    private isJobComplete(): boolean {
        return this.state.form.data.digStatus === 4;
    }

    private isFormDisabled(): boolean {
        return this.state.form.isSubmitting;
    }

    private isReleaseDisabled(): boolean {
        const roles = this.props.msalContext.accounts[0].idTokenClaims!.roles;
        const noAccess = !(roles?.includes('HotJobs.Default') === true);

        //Disable if any files have not been uploaded:
        const filesNotUploaded = !this.state.form.data.lsbudStatus ||
            !this.state.form.data.electricStatus ||
            !this.state.form.data.gasStatus ||
            !this.state.form.data.waterStatus ||
            !this.state.form.data.bapaStatus ||
            !this.state.form.data.telecomsStatus;

        //Disable if there are any open tasks:
        let openTask = false;
        this.state.form.tasks.rowData.forEach(t => {
            if(t.data.taskStatus === 1) {
                openTask = true;
            }
        });

        //Disable if job is in Quarantine
        const quarantined = this.state.form.data.quarantine;

        return this.isFormDisabled() || noAccess|| filesNotUploaded || openTask || quarantined || this.isJobComplete();
    }

    private isSendButtonDisabled(): boolean {
        //Only allow hot jobs to be sent after the scheduled date.
        const scheduleDisable = this.state.form.data.hotJob
                && (this.state.form.data.supervisionDate === null
                    || this.state.form.data.supervisionDate > new Date()
                );

        const filesUploaded = this.state.form.data.lsbudStatus &&
            this.state.form.data.electricStatus &&
            this.state.form.data.gasStatus &&
            this.state.form.data.waterStatus &&
            this.state.form.data.bapaStatus &&
            this.state.form.data.telecomsStatus;

        const sendOk = (this.state.form.data.digStatus === 3 || this.state.form.data.digStatus === 4) && filesUploaded;

        return !sendOk
            || scheduleDisable;
    }

    private isCancelButtonDisabled(): boolean {
        const roles = this.props.msalContext.accounts[0].idTokenClaims!.roles;
        const noAccess = !(roles?.includes('HotJobs.Default') === true);

        return noAccess || this.state.form.data.digStatus === 6;
    }

    private releaseButton_Click(): void {
        this.m_jobReleaseRef.current!.show(this.state.form.data.hotJob, this.state.form.data.estimate);
    }

    private send_Click(): void {
        this.m_jobSendRef.current!.show(this.state.form.data.estimate);
    }

    private cancel_Click(): void {
        this.m_cancelRef.current?.show(this.state.form.data.estimate);
    }

    private async cancelDialog_onClose(): Promise<void> {
        const result = await this.m_safedigClient.callWithReply(
            CancelSafeDigReply, (client) => client.cancelJob(this.state.form.data.estimate));
        result.throwIfFailed();

        await this.page_onLoadData();
    }

    private async goto_Click(): Promise<void> {
        const safeDigId = this.state.form.data.parent;
        this.props.navigate(`/safedigs/${safeDigId}`);
        window.location.reload();
    }

    /** */
    private closeButton_Click(): void {
        this.props.navigate('/safedigs');
    }

    private form_onBeforeSubmit(fieldValues: SafeDig, formikHelpers: FormikHelpers<SafeDig>): boolean {

        const cancel = false;
        this.m_pageRef.current!.messageBar.close();
        this.safeSetState((draft: State) => draft.form.isSubmitting = true);
        return cancel;

    }

    private async form_onSubmit(fieldValues: SafeDig, formikHelpers: FormikHelpers<SafeDig>): Promise<void> {
        const userName = this.props.msalContext.accounts[0].name;

        const updateRequest = new UpdateSafeDigRequest({
            safeDigsId: fieldValues.safeDigsId,
            project: fieldValues.project,
            estimate: fieldValues.estimate.replace(/"/g, ''),
            requestor: fieldValues.requestor,
            address1: fieldValues.address1.replace(/"/g, ''),
            address2: fieldValues.address2.replace(/"/g, ''),
            address3: fieldValues.address3.replace(/"/g, ''),
            county: this.m_areaValue,
            postcode: fieldValues.postcode.replace(/"/g, ''),
            workDescription: fieldValues.workDescription.replace(/"/g, ''),
            northing: fieldValues.northing,
            easting: fieldValues.easting,
            northing2: fieldValues.northing2,
            easting2: fieldValues.easting2,
            requiredDate: fieldValues.requiredDate!,
            receivedDate: fieldValues.receivedDate!,
            digStatus: fieldValues.digStatus,
            user: userName,
            parent: fieldValues.parent
        });

        const result = await this.m_safedigClient.callWithReply(UpdateSafeDigReply, (client) => client.update(updateRequest));

        result.throwIfFailed();

        this.m_updateCount = result.reply!.value;
    }

    /** */
    private form_onAfterSubmit(outcome: MFormOutcome, fieldValues: SafeDig, formikHelpers: FormikHelpers<SafeDig>, exception: any | undefined): void {

        this.safeSetState(
            (draft: State) => draft.form.isSubmitting = false);

        if(outcome === 'success') {

            this.m_pageRef.current!.messageBar.success(`Total safe dig update count = ${this.m_updateCount}.`);
        }
    }

    /** */
    private form_onError(exception: any): boolean {

        const handled = false;
        this.m_pageRef.current!.messageBar.error(toErrorMessage(exception));
        return handled;

    }

    private async page_onLoadData(): Promise<void> {
        const id = this.props.match.params.id;

        await this.readProjectList();

        //Pull safe dig data
        const result = await this.m_safedigClient.callWithReply(SafeDigReply, (client) => client.get(id));
        result.throwIfFailed();
        this.setSafedig(result.reply!.data!);

        await this.readLineExpiryDates(result.reply!.data!.safeDigsId);
        await this.readStatusMessages(result.reply!.data!.safeDigsId);
        await this.readFileData(result.reply!.data!.safeDigsId);
        await this.readTaskData(result.reply!.data!.safeDigsId);
        await this.readAuditData(result.reply!.data!.safeDigsId);
        await this.readNoteData(result.reply!.data!.safeDigsId);
        if(result.reply!.data!.parent === -1) {
            await this.readSubJobs(result.reply!.data!.safeDigsId);
        }
        await this.readNoticeData(result.reply!.data!.safeDigsId);

    }

    private checkNearExpiry(status: number, expiryDate: Date): number {
        const currentDate = new Date();
        var futureDate = new Date();
        futureDate.setDate(futureDate.getDate() + 7);

        if (!expiryDate)
        {
            return status;
        }

        if (status === 2 && expiryDate < futureDate && expiryDate > currentDate)
        {
            return 6;
        }

        return status;
    }

    private async readLineExpiryDates(safeDigsId: number){
        const fileData = await this.m_safedigFileClient.callWithReply(
            SafeDigFileListReply,
            (client) => client.get(safeDigsId, -1, 0));
        fileData.throwIfFailed();

        const expiryDate = new Date();
        expiryDate.setHours(0, 0, 0, 0);

        const gasFile = fileData.reply!.data.filter(fd => fd.fileType === 1 && fd.expiryDate > expiryDate);
        const electricFile = fileData.reply!.data.filter(fd => fd.fileType === 2 && fd.expiryDate > expiryDate);
        const waterFile = fileData.reply!.data.filter(fd => fd.fileType === 3 && fd.expiryDate > expiryDate);
        const bapaFile = fileData.reply!.data.filter(fd => fd.fileType === 4 && fd.expiryDate > expiryDate);
        const telecomsFile = fileData.reply!.data.filter(fd => fd.fileType === 5 && fd.expiryDate > expiryDate);
        const lsbudFile = fileData.reply!.data.filter(fd => fd.fileType === 6 && fd.expiryDate > expiryDate);

        this.safeSetState(draft => {
            draft.expiryDates.gas = gasFile.length > 0 ? gasFile[0].expiryDate : null;
            draft.form.data.gasStatus = gasFile.length > 0 ? this.checkNearExpiry(gasFile[0].fileStatus, gasFile[0].expiryDate) : 0;
            draft.expiryDates.electric = electricFile.length > 0 ? electricFile[0].expiryDate : null;
            draft.form.data.electricStatus = electricFile.length > 0 ? this.checkNearExpiry(electricFile[0].fileStatus, electricFile[0].expiryDate) : 0;
            draft.expiryDates.water = waterFile.length > 0 ? waterFile[0].expiryDate : null;
            draft.form.data.waterStatus = waterFile.length > 0 ? this.checkNearExpiry(waterFile[0].fileStatus, waterFile[0].expiryDate) : 0;
            draft.expiryDates.bapa = bapaFile.length > 0 ? bapaFile[0].expiryDate : null;
            draft.form.data.bapaStatus = bapaFile.length > 0 ? this.checkNearExpiry(bapaFile[0].fileStatus, bapaFile[0].expiryDate) : 0;
            draft.expiryDates.telecoms = telecomsFile.length > 0 ? telecomsFile[0].expiryDate : null;
            draft.form.data.telecomsStatus = telecomsFile.length > 0 ? this.checkNearExpiry(telecomsFile[0].fileStatus, telecomsFile[0].expiryDate) : 0;
            draft.expiryDates.lsbud = lsbudFile.length > 0 ? lsbudFile[0].expiryDate : null;
            draft.form.data.lsbudStatus = lsbudFile.length > 0 ? this.checkNearExpiry(lsbudFile[0].fileStatus, lsbudFile[0].expiryDate) : 0;
        });
    }

    private async readExpiryDate(safeDigsId: number, fileType: number): Promise<MNullable<Date>> {
        const fileData = await this.m_safedigFileClient.callWithReply(
            SafeDigFileListReply,
            (client) => client.get(safeDigsId, fileType, 0));
        fileData.throwIfFailed();

        if(fileData.reply!.data.length === 0)
            return null;

        return fileData.reply!.data[0].expiryDate;
    }

    private async readStatusMessages(safeDigsId: number) {

        //Display any status messages for the entry.
        this.m_messageRef.current!.clear();
        const messageResult = await this.m_safedigClient.callWithReply(StatusMessageReply, (client) => client.getMessages(safeDigsId));

        messageResult.throwIfFailed();

        this.m_messageRef.current!.show(messageResult.reply!.data.map((item) => (
            {
                sticky: true,
                severity : this.getMessageTypeString(item.type),
                detail: item.message,
                closable: false,
            }
        )));
    }

    private async readFileData(safeDigsId: number) {
        const filesResult = await this.m_safedigFileClient.callWithReply(SafeDigFileListReply,
            (client) => client.getMisc(safeDigsId, 0));

        filesResult.throwIfFailed();

        this.safeSetState((draft: State) => {

            draft.form.files.rowData = filesResult.reply!.data!.map((w: SafeDigFile) => {
                return {data: w} as SafeDigFileRow;
            });
        });
    }

    private async readTaskData(safeDigsId: number) {
        //pull task data.
        const taskResult = await this.m_safedigTaskClient.callWithReply(SafeDigTaskListReply, (client) => client.getAll(safeDigsId));

        taskResult.throwIfFailed();

        this.safeSetState((draft: State) => {

            draft.form.tasks.rowData = taskResult.reply!.data!.map((w: SafeDigTask) => {
                return {data: w} as SafeDigTaskRow;
            });
        });
    }

    private async readAuditData(safeDigsId: number) {
        //pull task data.
        const taskResult = await this.m_auditlogClient.callWithReply(AuditLogListReply, (client) => client.getDigAudit(safeDigsId, 0));

        taskResult.throwIfFailed();

        this.safeSetState((draft: State) => {

            draft.form.audit.rowData = taskResult.reply!.data!.map((w: AuditLog) => {
                return {data: w} as AuditLogRow;
            });
        });
    }

    private async readProjectList() {
        const projectResult = await this.m_safedigClient.callWithReply(
            ProjectReply, (client) => client.getProjects());

        projectResult.throwIfFailed();

        const listRows = projectResult.reply!.data.map(project => ({
            value: project.id,
            label: project.name
        }));

        this.safeSetState((draft) => {
            draft.projectList = listRows;
            draft.form.data.project = 1;
        });
    }

    private async readNoteData(safeDigsId: number) {
        const notesResult = await this.m_safedigClient.callWithReply(
            SafeDigNoteReply, (client) => client.getNotes(safeDigsId));

        notesResult.throwIfFailed();

        this.safeSetState((draft: State) => {
            draft.form.notes.rowData = notesResult.reply!.data!.map((w: Note) => {
                return {data: w} as SafeDigNoteRow;
            });
        });
    }

    private async readSubJobs(safeDigsId: number) {
        const subResult = await this.m_safedigClient.callWithReply(
            SafeDigListReply,  (client) => client.getSubJobs(this.state.form.data.safeDigsId));

        subResult.throwIfFailed();

        this.safeSetState((draft: State) => {
           draft.form.subJobs.rowData = subResult.reply!.data!.map((s:SafeDig) => {
               return {data: s} as SubJobRow;
           })
        });
    }

    private async readNoticeData(safeDigsId: number) {
        const noticeResult = await this.m_noticeClient.callWithReply(
            NoticeReplyMulti, (client) => client.listSafeDigNotices(safeDigsId));
        noticeResult.throwIfFailed();

        this.safeSetState((draft: State) => {
            draft.form.notices = noticeResult.reply!.notices!;
        });
    }

    private getMessageTypeString(msgType: number): MessagesSeverityType {
        switch(msgType) {
            case 1:
                return 'success';
            case 3:
                return 'warn';
            case 4:
                return 'error';
            default:
                return 'info';
        }
    }

    private setSafedig(safedigdata: SafeDig): void {

        this.safeSetState((draft: State) => {

            draft.pageTitle = `${safedigdata.estimate}`;
            draft.pageSubtitle = 'Edit Safe Dig';
            draft.form.data = safedigdata;

        });

        this.m_projectRef.current?.setValue(safedigdata.project);
        this.m_areaRef.current!.setValue(JobAreas.includes(safedigdata.county) ? safedigdata!.county : 'Other');
        this.m_areaValue = safedigdata!.county;
    }

    private async saveTaskData(data: TaskData, newEntry: boolean): Promise<void> {
        const userName = this.props.msalContext.accounts[0].name;
        const timeZoneChange = new Date().getTimezoneOffset();
        data.dueDate?.setMinutes(data.dueDate?.getMinutes() - timeZoneChange);

        if(newEntry) {
            const createRequest = new CreateSafeDigTaskRequest({
                taskSubType: data.taskSubType,
                safeDigsId: this.state.form.data.safeDigsId,
                taskType: 1,
                comment: data.comment,
                dueDate: data.dueDate!,
                taskStatus: data.taskComplete ? 2 : 1,
                user: userName
            });
            await this.m_safedigTaskClient.callWithReply(CreateSafeDigTaskReply, (client) => client.post(createRequest));
        } else {
            const updateRequest = new UpdateSafeDigTaskRequest({
                safeDigTasksId: data.taskId,
                taskSubType: data.taskSubType,
                safeDigsId: this.state.form.data.safeDigsId,
                taskType: 1,
                comment: data.comment,
                dueDate: data.dueDate!,
                taskStatus: data.taskComplete ? 2 : 1,
                user: userName
            });
            await this.m_safedigTaskClient.callWithReply(UpdateSafeDigReply, (client) => client.update(updateRequest));
        }

        data.supervisionDate?.setMinutes(data.supervisionDate?.getMinutes() - timeZoneChange);
        if(data.taskSubType === 1) {
            const supervisionRequest = new SafeDigUpdateSupervisionRequest({
                safeDigId: this.state.form.data.safeDigsId,
                supervisionDate: data.supervisionDate,
                user: userName
            });
            await this.m_safedigClient.callWithReply(UpdateSafeDigReply, (client) => client.updateSupervision(supervisionRequest));
        }
        this.page_onLoadData();
    }

    private async ChangeFileIncludeStatus(safeDigFileId: number, newValue: boolean) {
        await this.m_safedigFileClient.callWithReply(UpdateSafeDigFileReply, (client) => client.changeFileIncludeState(safeDigFileId, newValue));
        await this.readFileData(this.state.form.data.safeDigsId);
    }

    private async fileStatusDialog_Close(fileType: number, result: FileStatusResult) {
        const userName = this.props.msalContext.accounts[0].name;

        if(result === FileStatusResult.Archive) {
            const changeRequest = new ChangeFileStateRequest({
                safeDigsId: this.state.form.data.safeDigsId,
                fileType: fileType,
                fileArea: 0,
                oldStatus: 2,
                newStatus: 3,
                user: userName
            });

            const result = await this.m_safedigFileClient.callWithReply(
                UpdateSafeDigFileReply,
                (client) => client.changeFileState(changeRequest));

            result.throwIfFailed();

            await this.page_onLoadData();
        } else if(result === FileStatusResult.Download) {
            const result = await this.m_safedigFileClient.callWithReply(
                UpdateSafeDigFileReply,
                (client) => client.download(this.state.form.data.safeDigsId, fileType, 0));

            result.throwIfFailed();
        }
        //For FileStatusResult.Cancel, no action required.
    }

    private async jobReleaseDialog_Close() {
        const userName = this.props.msalContext.accounts[0].name;

        await this.m_safedigClient.call((client) => client.releaseJob(this.state.form.data.safeDigsId, userName!));

        this.page_onLoadData();
    }

    /** */
    private getToolbarTemplate(): ReactElement<MToolbar> {

        return (
            <React.Fragment>
                <MToolbar>
                    <MButton formId={this.state.form.id}
                             label="Save"
                             type="submit"
                             color="success"
                             icon={MSaveIconName}
                             isBusy={this.isFormDisabled}
                             disabled={this.isJobComplete}/>
                    <MSpacer/>
                    <MButton label="Release"
                             color="success"
                             icon={ReleaseIconName}
                             disabled={this.isReleaseDisabled}
                             onClick={this.releaseButton_Click}/>
                    <MSpacer/>
                    <MButton label="Send"
                             icon={SendIconName}
                             iconOnly={false}
                             disabled={this.isSendButtonDisabled}
                             onClick={this.send_Click}/>
                    <MSpacer/>
                    {(this.state.form.data.parent !== -1) && <React.Fragment>
                        <MButton label="Parent"
                             icon={GotoIconName}
                             iconOnly={false}
                             disabled={false}
                             onClick={this.goto_Click}/>
                        <MSpacer/>
                    </React.Fragment>}
                    <MButton label="Cancel Job"
                             color="danger"
                             icon={'pi pi-trash'}
                             iconOnly={false}
                             disabled={this.isCancelButtonDisabled}
                             onClick={this.cancel_Click}/>
                    <MSpacer/>
                    <MButton label="Close"
                             icon={MCloseIconName}
                             disabled={this.isFormDisabled}
                             onClick={this.closeButton_Click}/>
                    {this.state.form.data.hotJob && <div style={{margin: 'auto'}}><img src={skullLogo} alt="HJ" /></div>}
                </MToolbar>

                <Messages ref={this.m_messageRef}/>
            </React.Fragment>
        );

    }

    private async onFileStatusClicked(fileType: number): Promise<void> {

        const roles = this.props.msalContext.accounts[0].idTokenClaims!.roles;
        const hotJobsPermission = roles?.includes('HotJobs.Default') === true;
        let archivePermission = true;

        let validFile = false;
        switch(fileType) {
            case 1:
                validFile = this.state.form.data.gasStatus === 2;
                break;
            case 2:
                validFile = this.state.form.data.electricStatus === 2;
                break;
            case 3:
                validFile = this.state.form.data.waterStatus === 2;
                break;
            case 4:
                validFile = this.state.form.data.bapaStatus === 2;
                break;
            case 5:
                validFile = this.state.form.data.telecomsStatus === 2;
                break;
            case 6:
                validFile = this.state.form.data.lsbudStatus === 2;
                archivePermission = hotJobsPermission;
                break;
        }

        if(validFile) {
            const fileData = await this.m_safedigFileClient.callWithReply(
                SafeDigFileListReply,
                (client) => client.get(this.state!.form!.data.safeDigsId, fileType, 0));
            this.m_fileStatusRef.current!.show({
                    estimate: this.state.form.data.estimate,
                    fileType: fileType,
                    fileInfo: fileData.reply!.data[0].fileInfo,
                    expiryDate: fileData.reply!.data[0].expiryDate
                },
                archivePermission);
        } else {
            this.m_fileUploadRef.current!.show(this.onUploadFile, fileType);
        }
    }

    public onFileListRefresh(): void {
        this.readFileData(this.state.form.data.safeDigsId);
    }

    private onNavigate(estimate: number, newEntry: boolean) : void {
        if(newEntry) {
            this.props.navigate(`/safedigs/create/${this.state.form.data.safeDigsId}/${this.state.form.subJobs.rowData.length}`);
        } else {
            this.props.navigate(`/safedigs/${estimate}`);
            window.location.reload();
        }
    }

    public render(): ReactElement {
        const userName = this.props.msalContext.accounts[0].name;
        const roles = this.props.msalContext.accounts[0].idTokenClaims!.roles;
        const safeDigsPermission = roles?.includes('SafeDigs.Default') === true;

        return (
            <MPage title="Edit Safe Dig"
                   subtitle="Edit a Safe Dig request"
                   locked={this.state.page.locked}
                   width={8}
                   toolbar={this.getToolbarTemplate()}
                   onLoadData={this.page_onLoadData}
                   ref={this.m_pageRef}>
                <FileUploadDialog ref={this.m_fileUploadRef}
                                  jobComplete={this.isJobComplete()}
                                  uploadPermission={safeDigsPermission}
                />
                <FileStatusDialog ref={this.m_fileStatusRef}
                                  onDialogClose={this.fileStatusDialog_Close}
                                  jobComplete={this.isJobComplete()}
                />
                <JobReleaseDialog ref={this.m_jobReleaseRef} onDialogClose={this.jobReleaseDialog_Close}/>
                <JobSendDialog ref={this.m_jobSendRef} onDialogClose={this.jobSendDialog_onClose}/>
                <CancelDialog ref={this.m_cancelRef} onDialogClose={this.cancelDialog_onClose}/>

                <MForm formId={this.state.form.id}
                       initialValues={this.state.form.data}
                       validationSchema={this.state.form.validationSchema}
                       onBeforeSubmit={this.form_onBeforeSubmit}
                       onSubmit={this.form_onSubmit}
                       onError={this.form_onError}
                       onAfterSubmit={this.form_onAfterSubmit}
                       ref={this.m_formRef}>

                    <div className="formgrid grid">
                        <div className="col-12">
                            <MFormSection title="General">

                                <div className="col-12 md:col-4">
                                    <MFormFieldControl label="ID"
                                                       fieldName="estimate">
                                        {(fieldProps: FieldProps, fieldClasses: string | undefined) => {
                                            return (
                                                <MTextBox id={fieldProps.field.name}
                                                          maxLength={30}
                                                          fieldProps={fieldProps}
                                                          disabled={this.isFormDisabled}
                                                          className={fieldClasses}/>
                                            );
                                        }}
                                    </MFormFieldControl>
                                </div>

                                <div className="col-12 md:col-4">
                                    <MFormFieldControl label={'Project'}
                                                       fieldName={'Project'}>
                                        {(fieldProps: FieldProps, fieldClasses: string | undefined) => {
                                            return (
                                                <MDropDown<number> id="ProjectSelection"
                                                                   disabled={false}
                                                                   items={this.state.projectList}
                                                                   initialValue={this.state.form.data.project}
                                                                   ref={this.m_projectRef}
                                                />
                                            );
                                        }}
                                    </MFormFieldControl>
                                </div>

                                <div className="col-12 md:col-4">
                                    <MFormFieldControl label="Requestor"
                                                       fieldName="requestor">
                                        {(fieldProps: FieldProps, fieldClasses: string | undefined) => {
                                            return (
                                                <MTextBox id={fieldProps.field.name}
                                                          maxLength={100}
                                                          fieldProps={fieldProps}
                                                          disabled={true}
                                                          className={fieldClasses}/>
                                            );
                                        }}
                                    </MFormFieldControl>
                                </div>

                                <div className="col-12 md:col-4">
                                    <MFormFieldControl label="Received Date"
                                                       fieldName="receivedDate">

                                        {(fieldProps: FieldProps, fieldClasses: string | undefined) => {

                                            return (
                                                <MCalendar id={fieldProps.field.name}
                                                           fieldProps={fieldProps}
                                                           disabled={true}
                                                           className={fieldClasses}/>
                                            );

                                        }}

                                    </MFormFieldControl>
                                </div>

                                <div className="col-12 md:col-12">
                                    <MFormFieldControl label="Work Description"
                                                       fieldName="workDescription">
                                        {(fieldProps: FieldProps, fieldClasses: string | undefined) => {
                                            return (
                                                <TextArea id={fieldProps.field.name}
                                                          maxLength={500}
                                                          fieldProps={fieldProps}
                                                          disabled={this.isFormDisabled}
                                                          className={fieldClasses}
                                                           rows={5}/>
                                            );
                                        }}
                                    </MFormFieldControl>
                                </div>

                                <div className="col-12 md:col-4">
                                    <MFormFieldControl label="Required Date"
                                                       fieldName="requiredDate">

                                        {(fieldProps: FieldProps, fieldClasses: string | undefined) => {

                                            return (
                                                <MCalendar id={fieldProps.field.name}
                                                           fieldProps={fieldProps}
                                                           disabled={this.isFormDisabled}
                                                           className={fieldClasses}/>
                                            );

                                        }}

                                    </MFormFieldControl>
                                </div>
                            </MFormSection>
                        </div>

                        <div className="col-12">
                            <Divider/>
                            <MFormSection title="Location">

                                <div className="col-12 md:col-6">
                                    <MFormFieldControl label="Start location - Eastings"
                                                       fieldName="easting">
                                        {(fieldProps: FieldProps, fieldClasses: string | undefined) => {
                                            return (
                                                <MNumericBox id={fieldProps.field.name}
                                                             maxLength={8}
                                                             fieldProps={fieldProps}
                                                             disabled={this.isFormDisabled}
                                                             className={fieldClasses}
                                                             decimalPlaces={0}
                                                             useGrouping={false}/>
                                            );
                                        }}
                                    </MFormFieldControl>
                                </div>

                                <div className="col-12 md:col-6">
                                    <MFormFieldControl label="Start location - Northings"
                                                       fieldName="northing">
                                        {(fieldProps: FieldProps, fieldClasses: string | undefined) => {
                                            return (
                                                <MNumericBox id={fieldProps.field.name}
                                                             maxLength={8}
                                                             fieldProps={fieldProps}
                                                             disabled={this.isFormDisabled}
                                                             className={fieldClasses}
                                                             decimalPlaces={0}
                                                             useGrouping={false}/>
                                            );
                                        }}
                                    </MFormFieldControl>
                                </div>

                                <div className="col-12 md:col-6">
                                    <MFormFieldControl label="End location - Eastings"
                                                       fieldName="easting2">
                                        {(fieldProps: FieldProps, fieldClasses: string | undefined) => {
                                            return (
                                                <MNumericBox id={fieldProps.field.name}
                                                             maxLength={8}
                                                             fieldProps={fieldProps}
                                                             disabled={this.isFormDisabled}
                                                             className={fieldClasses}
                                                             decimalPlaces={0}
                                                             useGrouping={false}/>
                                            );
                                        }}
                                    </MFormFieldControl>
                                </div>

                                <div className="col-12 md:col-6">
                                    <MFormFieldControl label="End location - Northings"
                                                       fieldName="northing2">
                                        {(fieldProps: FieldProps, fieldClasses: string | undefined) => {
                                            return (
                                                <MNumericBox id={fieldProps.field.name}
                                                             maxLength={8}
                                                             fieldProps={fieldProps}
                                                             disabled={this.isFormDisabled}
                                                             className={fieldClasses}
                                                             decimalPlaces={0}
                                                             useGrouping={false}/>
                                            );
                                        }}
                                    </MFormFieldControl>
                                </div>
                            </MFormSection>
                        </div>

                        <div className="col-12">
                            <Divider/>
                            <MFormSection title="Line Search Files">

                                <div className="col-12 md:col-2">
                                    <MFormControl label={''} id="lsbudStatus">
                                        {() => {
                                            return (
                                                <StatusControl size={40}
                                                               initialValue={this.state.form.data.lsbudStatus}
                                                               onClick={this.onFileStatusClicked.bind(this, 6)}
                                                               label={'LSBUD'}
                                                               expiryDate={this.state.expiryDates.lsbud}
                                                />
                                            );
                                        }}
                                    </MFormControl>
                                </div>

                                <div className="col-12 md:col-2">
                                    <MFormControl label={''} id="electricStatus">
                                        {() => {
                                            return (
                                                <StatusControl size={40}
                                                               initialValue={this.state.form.data.electricStatus}
                                                               onClick={this.onFileStatusClicked.bind(this, 2)}
                                                               label={'Electric'}
                                                               expiryDate={this.state.expiryDates.electric}
                                                />
                                            );
                                        }}
                                    </MFormControl>
                                </div>

                                <div className="col-12 md:col-2">
                                    <MFormControl label={''} id={'Gas'}>
                                        {() => {
                                            return (
                                                <StatusControl size={40}
                                                               initialValue={this.state.form.data.gasStatus}
                                                               onClick={this.onFileStatusClicked.bind(this, 1)}
                                                               label={'Gas'}
                                                               expiryDate={this.state.expiryDates.gas}
                                                />
                                            );
                                        }}
                                    </MFormControl>
                                </div>

                                <div className="col-12 md:col-2">
                                    <MFormControl label={''} id={'Water'}>
                                        {() => {
                                            return (
                                                <StatusControl size={40}
                                                               initialValue={this.state.form.data.waterStatus}
                                                               onClick={this.onFileStatusClicked.bind(this, 3)}
                                                               label={'Water'}
                                                               expiryDate={this.state.expiryDates.water}
                                                />
                                            );
                                        }}
                                    </MFormControl>
                                </div>

                                <div className="col-12 md:col-2">
                                    <MFormControl label={''} id={'Bapa'}>
                                        {() => {
                                            return (
                                                <StatusControl size={40}
                                                               initialValue={this.state.form.data.bapaStatus}
                                                               onClick={this.onFileStatusClicked.bind(this, 4)}
                                                               label={'BAPA'}
                                                               expiryDate={this.state.expiryDates.bapa}
                                                />
                                            );
                                        }}
                                    </MFormControl>
                                </div>

                                <div className="col-12 md:col-2">
                                    <MFormControl label={''} id={'Telecoms'}>
                                        {() => {
                                            return (
                                                <StatusControl size={40}
                                                               initialValue={this.state.form.data.telecomsStatus}
                                                               onClick={this.onFileStatusClicked.bind(this, 5)}
                                                               label={'Telecoms'}
                                                               expiryDate={this.state.expiryDates.telecoms}
                                                />
                                            );
                                        }}
                                    </MFormControl>
                                </div>
                            </MFormSection>
                        </div>

                        <div className="col-12">
                            <Divider/>
                            <MFormSection title="Documents">

                                <div className="min-w-full">
                                    <FileListControl rowData={this.state.form.files.rowData}
                                                     updateIncludeState={this.ChangeFileIncludeStatus}
                                                     addFile={this.onFileStatusClicked.bind(this, 7)}
                                                     refresh={this.onFileListRefresh}
                                                     fileClient={this.m_safedigFileClient}
                                                     jobComplete={this.isJobComplete()}
                                                     user={userName!}
                                                     uploadPermission={safeDigsPermission}
                                                     role={roles!}
                                    />
                                </div>
                            </MFormSection>
                        </div>

                        <div className="col-12">
                            <Divider/>
                            <MFormSection title="Address">

                                <div className="col-12 md:col-4">
                                    <MFormFieldControl label="Address1"
                                                       fieldName="address1">
                                        {(fieldProps: FieldProps, fieldClasses: string | undefined) => {
                                            return (
                                                <MTextBox id={fieldProps.field.name}
                                                          maxLength={50}
                                                          fieldProps={fieldProps}
                                                          disabled={this.isFormDisabled}
                                                          className={fieldClasses}/>
                                            );
                                        }}
                                    </MFormFieldControl>
                                </div>

                                <div className="col-12 md:col-4">
                                    <MFormFieldControl label="Address2"
                                                       fieldName="address2">
                                        {(fieldProps: FieldProps, fieldClasses: string | undefined) => {
                                            return (
                                                <MTextBox id={fieldProps.field.name}
                                                          maxLength={50}
                                                          fieldProps={fieldProps}
                                                          disabled={this.isFormDisabled}
                                                          className={fieldClasses}/>
                                            );
                                        }}
                                    </MFormFieldControl>
                                </div>

                                <div className="col-12 md:col-4">
                                    <MFormFieldControl label="Address3"
                                                       fieldName="address3">
                                        {(fieldProps: FieldProps, fieldClasses: string | undefined) => {
                                            return (
                                                <MTextBox id={fieldProps.field.name}
                                                          maxLength={50}
                                                          fieldProps={fieldProps}
                                                          disabled={this.isFormDisabled}
                                                          className={fieldClasses}/>
                                            );
                                        }}
                                    </MFormFieldControl>
                                </div>
                                
                                <div className="col-12 md:col-4">
                                    <MFormFieldControl label="Build Area"
                                                       fieldName="county">
                                        {(fieldProps: FieldProps, fieldClasses: string | undefined) => {
                                            return (
                                                <MDropDown<string> id="AreaSelection"
                                                                   ref={this.m_areaRef}
                                                                   disabled={false}
                                                                   items={JobAreas.map(area => ({
                                                                       value: area,
                                                                       label: area
                                                                   }))}
                                                                   initialValue={'Aintree'}
                                                                   onChange={(e) => this.m_areaValue = e! }
                                                />
                                            );
                                        }}
                                    </MFormFieldControl>
                                </div>

                                <div className="col-12 md:col-4">
                                    <MFormFieldControl label="Postcode"
                                                       fieldName="postcode">
                                        {(fieldProps: FieldProps, fieldClasses: string | undefined) => {
                                            return (
                                                <MTextBox id={fieldProps.field.name}
                                                          maxLength={50}
                                                          fieldProps={fieldProps}
                                                          disabled={this.isFormDisabled}
                                                          className={fieldClasses}/>
                                            );
                                        }}
                                    </MFormFieldControl>
                                </div>
                            </MFormSection>
                        </div>

                        <div className="col-12">
                            <Divider/>
                            <MFormSection title="Notes">

                                <div className="min-w-full">
                                    <NoteListControl rowData={this.state.form.notes.rowData}
                                                     saveNote={this.onNewNote}
                                                     jobComplete={this.isJobComplete()}
                                    />
                                </div>
                            </MFormSection>
                        </div>

                        <div className="col-12">
                            <Divider/>
                            <MFormSection title="Task List">

                                <div className="min-w-full">
                                    <TaskListControl rowData={this.state.form.tasks.rowData}
                                                     saveTaskData={this.saveTaskData}
                                                     supervisionDate={this.state.form.data.supervisionDate}
                                                     jobComplete={this.isJobComplete()}
                                    />
                                </div>
                            </MFormSection>
                        </div>

                        <div className="col-12">
                            <Divider/>
                            <MFormSection title="Notices">

                                <div className="min-w-full">
                                    <NoticeListControl safeDigId={this.state.form.data.safeDigsId}
                                                       rowData={this.state.form.notices}
                                                       history={this.props.history}
                                                       navigate={this.props.navigate}
                                                       match={this.props.match}
                                                       location={this.props.location}/>
                                </div>
                            </MFormSection>
                        </div>

                        {this.state.form.data.parent === -1 && <div className="col-12">
                            <Divider/>
                            <MFormSection title="Additional Works Requests">

                                <div className="min-w-full">
                                    <SubJobControl rowData={this.state.form.subJobs.rowData}
                                                   navigateTo={this.onNavigate}
                                    />
                                </div>
                            </MFormSection>
                        </div>}

                        <div className="col-12">
                            <Divider/>
                            <MFormSection title="History">

                                <div className="min-w-full">
                                    <AuditListControl rowData={this.state.form.audit.rowData}/>
                                </div>
                            </MFormSection>
                        </div>
                    </div>

                </MForm>
            </MPage>
        );
    }
}

export default withMsal(WithRouter(EditSafeDigPage));